var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 448,
    viewBox: "0 0 321 448",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.678 9.375C170.178 -3.125 149.878 -3.125 137.378 9.375L9.37778 137.375C0.177778 146.575 -2.52222 160.275 2.47778 172.275C7.47778 184.275 19.0778 192.075 32.0778 192.075H288.078C300.978 192.075 312.678 184.275 317.678 172.275C322.678 160.275 319.878 146.575 310.778 137.375L182.778 9.375H182.678Z",
    fill: "#6AC3DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.678 437.7C170.178 450.2 149.878 450.2 137.378 437.7L9.37778 309.7C0.177778 300.5 -2.52222 286.8 2.47778 274.8C7.47778 262.8 19.0778 255 32.0778 255H288.078C300.978 255 312.678 262.8 317.678 274.8C322.678 286.8 319.878 300.5 310.778 309.7L182.778 437.7H182.678Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUp);
export default __webpack_public_path__ + "static/media/sort-up.e22b8b8368ea4394e7e34b56b655b9b3.svg";
export { ForwardRef as ReactComponent };